import { render, staticRenderFns } from "./LogoComponent.vue?vue&type=template&id=ebeec2bc"
import script from "./LogoComponent.vue?vue&type=script&lang=js"
export * from "./LogoComponent.vue?vue&type=script&lang=js"
import style0 from "./LogoComponent.vue?vue&type=style&index=0&id=ebeec2bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports